import React from 'react';
import { graphql, useFragment } from 'react-relay';

import {
  PromotionProblemEventDescriptionList_promotion$data,
  PromotionProblemEventDescriptionList_promotion$key,
} from '../../../relay/__generated__/PromotionProblemEventDescriptionList_promotion.graphql';
import { getDurationText } from '../../../utils/date';
import { numberWithCommas } from '../../../utils/number';
import DescriptionList, { DescriptionListProps } from '../../core/DescriptionList';
import Text from '../../core/Text';

const PromotionProblemEventDescriptionList_promotion = graphql`
  fragment PromotionProblemEventDescriptionList_promotion on Promotion {
    problemEvent {
      durationDays
      durationHours
      count
      offsetHours
    }
  }
`;

type Props = {
  promotion: PromotionProblemEventDescriptionList_promotion$key;
} & Omit<
  DescriptionListProps<PromotionProblemEventDescriptionList_promotion$data>,
  'item' | 'itemDescriptions' | 'picks'
>;
const PromotionProblemEventDescriptionList = ({ promotion: promotionReference, ...props }: Props) => {
  const promotion = useFragment(PromotionProblemEventDescriptionList_promotion, promotionReference);

  return (
    <DescriptionList
      item={promotion}
      itemDescriptions={{
        title: {
          title: '문제 수',
          renderValue: ({ problemEvent }) =>
            problemEvent?.count ? <Text fontSize={1}>{numberWithCommas(problemEvent?.count)}</Text> : null,
        },
        offset: {
          title: '오프셋',
          renderValue: ({ problemEvent }) =>
            problemEvent?.offsetHours ? <Text fontSize={1}>{problemEvent?.offsetHours}시간</Text> : undefined,
        },
        duration: {
          title: '지속시간',
          renderValue: ({ problemEvent }) =>
            typeof problemEvent?.durationDays === 'number' || typeof problemEvent?.durationHours === 'number' ? (
              <Text fontSize={1}>
                {getDurationText({ days: problemEvent?.durationDays, hours: problemEvent?.durationHours })}
              </Text>
            ) : undefined,
        },
      }}
      picks={['title', 'offset', 'duration']}
      {...props}
    />
  );
};

export default PromotionProblemEventDescriptionList;
